module.exports = __webpack_public_path__ + "img/al6.eeed56d0.png";